import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

/**
 * Frontend Supabase client — ANON KEY ONLY.
 *
 * The `service_role` key never appears in `src/`. It lives exclusively in the
 * Worker (worker/lib/supabase.ts). See CLAUDE.md, invariant 2.
 *
 * Both domains authenticate against the same Supabase project with two
 * independent sessions; sessions do not cross domains and are not meant to
 * (docs/ARCHITECTURE.md §2).
 */
const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    'Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY. Copy .env.example to .env.',
  );
}

export type TypedSupabaseClient = SupabaseClient<Database>;

export const supabase: TypedSupabaseClient = createClient<Database>(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // Scoped per domain, so numtable.com and procalendar.app never collide.
    storageKey: `sb-${typeof window !== 'undefined' ? window.location.hostname : 'localhost'}-auth`,
  },
});
